import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const GooglePagination = ({ 
  currentPage, 
  totalPages, 
  totalCount, 
  pageSize, 
  onPageChange,
  className = "" 
}) => {
  const getVisiblePages = () => {
    const delta = 2; // Number of pages to show on each side of current page
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, "...");
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push("...", totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots.filter((item, index, array) => {
      if (item === "...") return true;
      return array.indexOf(item) === index;
    });
  };

  const visiblePages = getVisiblePages();
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className={`flex items-center justify-between ${className}`}>
      {/* Results info */}
      <div className="text-xs text-gray-400">
        Showing {startItem} to {endItem} of {totalCount} results
      </div>

      {/* Pagination controls */}
      <div className="flex items-center space-x-1">
        {/* Previous button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`flex h-8 w-8 items-center justify-center rounded-md border transition-all duration-200 ${
            currentPage === 1
              ? "cursor-not-allowed border-gray-600 text-gray-600"
              : "border-gray-500 text-gray-300 hover:border-brand-600 hover:bg-brand-500/40 hover:text-white"
          }`}
        >
          <MdChevronLeft size={16} />
        </button>

        {/* Page numbers */}
        {visiblePages.map((page, index) => (
          <React.Fragment key={index}>
            {page === "..." ? (
              <span className="flex h-8 w-8 items-center justify-center text-gray-400 text-xs">
                ...
              </span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`flex h-8 w-8 items-center justify-center rounded-md border text-xs font-medium transition-all duration-200 ${
                  currentPage === page
                    ? "border-brand-500 bg-primary-gradient text-white"
                    : "border-gray-500 text-gray-300 hover:border-brand-600 hover:bg-brand-500/40 hover:text-white"
                }`}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}

        {/* Next button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`flex h-8 w-8 items-center justify-center rounded-md border transition-all duration-200 ${
            currentPage === totalPages
              ? "cursor-not-allowed border-gray-600 text-gray-600"
              : "border-gray-500 text-gray-300 hover:border-brand-600 hover:bg-brand-600 hover:text-white"
          }`}
        >
          <MdChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default GooglePagination; 